import * as React from 'react';
import { connect } from 'react-redux';
import { getHomePageRoute } from '../../infrastructure/HomePageRoute';
import DropdownMenu from 'src/components/DropdownMenu/DropdownMenu';
import { Route } from 'react-router-dom';
import { IUserData } from '../../infrastructure/interfaces'
import './css/HeaderBar.css'

export interface IHeaderBarProps {
  userData?: IUserData;
}

const mapStateToProps = (state: any) => {
  return {
    userData: state.user.data,
  };
};

@(connect(mapStateToProps) as any)
export default class HeaderBar extends React.Component<IHeaderBarProps> {

  render() {

    return (
        <div className="header-container">
          <Route
            render={({ history }) => {
              return (
                <div>
                  <img src={require('./img/Loveland_logo.svg')}
                    className="loveland-logo-button"
                    onClick={() => {
                      const homePageRoute = (this.props.userData)
                        ? getHomePageRoute(this.props.userData.role)
                        : '/Home';
                      history.push(homePageRoute);
                    }}/>
                </div>
              );
            }}
          />
          
          <div className="header-container-right">
              <DropdownMenu
                  title={<img src={require('./img/admin.svg')} className="admin-logo"/>}
                  options={[{
                      title: 'Logout',
                      onClick: () => window.location.pathname = '/auth/logout',
                  }]}
              />
          </div>
        </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/components/HeaderBar/HeaderBar.tsx